const ROUTES = {
  dcDetail(id: string, subPath: string = "basic-details") {
    return `/d/registration/dc/${id}/${subPath}`
  },
  dcList(type: "dc" | "cpc" = "dc") {
    return `/d/registration/dc?type=${type}`
  },
  docks: "/d/registration/dock",
  dockDetail(id: string) {
    return `/d/registration/dock/${id}`
  },
}

export default ROUTES
